export const PRODUCT_ENTITIES_STATE_KEY = 'product-entities';
